import React from "react";

import { useTranslation } from "utils";

import { Flex } from "components";

type MissingDataGuidanceProps = {
  fieldsContributingToPayouts: number;

  totalFields: number;
};

export const MissingDataGuidance = ({ fieldsContributingToPayouts, totalFields }: MissingDataGuidanceProps) => {
  const { t } = useTranslation("fieldTimeline");

  const fieldsNotContributing = totalFields - fieldsContributingToPayouts;

  return (
    <Flex className="missing-data-guidance-container" vertical={true}>
      <Flex align="center">
        {fieldsNotContributing === 0 ? (
          <span className="missing-data-fields-text" data-testid="all-fields-contributing-text">
            {t("impactPanel.allFieldsContributing")}
          </span>
        ) : (
          <span className="missing-data-fields-text" data-testid="fields-not-contributing-text">
            {t("impactPanel.fieldsNotContributing", { fieldsNotContributing, totalFields })}
          </span>
        )}
      </Flex>
    </Flex>
  );
};
